var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktokPurple({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3571 19.14C15.4684 18.8559 11.3752 20.9554 9.0774 25.4385C5.63072 32.1631 8.47929 43.1666 19.9779 43.1666C31.4764 43.1666 31.8091 32.0555 31.8091 30.8915C31.8091 30.1154 31.8091 25.7765 31.8091 17.8746C34.2685 19.4324 36.3421 20.3701 38.0298 20.6877C39.7176 21.0054 40.7906 21.1462 41.2487 21.1101V14.6343C39.6876 14.4461 38.3376 14.0874 37.1987 13.5582C35.4903 12.7643 32.1028 10.5612 32.1028 7.33214C32.1051 7.34793 32.1051 6.51499 32.1028 4.83331H24.9847C24.9636 20.6494 24.9636 29.3354 24.9847 30.8915C25.0165 33.2255 23.2058 36.4905 19.5346 36.4905C15.8633 36.4905 14.0526 33.2282 14.0526 31.1239C14.0526 29.8357 14.495 27.9685 16.3241 26.5858C17.4088 25.7659 18.9143 25.4385 21.3571 25.4385C21.3571 24.6829 21.3571 22.5834 21.3571 19.14Z",
    fill: "white",
    stroke: "#8601C9",
    strokeWidth: 3.833,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokPurple);
export default __webpack_public_path__ + "static/media/tiktokPurple.50363bb3.svg";
export { ForwardRef as ReactComponent };